const { CircularProgress } = window.Material;

interface LoaderProps {
  text?: string;
}

export default class Loader extends React.PureComponent<LoaderProps> {
  render() {
    const { text } = this.props;

    return (
      <div className="React-Loading--container">
        <CircularProgress />
        {text && <p className="React-Loading--message">{text}</p>}
      </div>
    );
  }
}
